
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/transparent-background",
      function () {
        return require("private-next-pages/transparent-background/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/transparent-background"])
      });
    }
  